<template>
  <div class="notice-root">
    <!-- 顶部导航 -->
    <Topbar />
    <!-- 主体区域 -->
    <el-container style="height: calc(100vh - 64px);">
      <!-- 左侧导航 -->
      <el-aside width="220px" class="sidebar">
        <div class="sidebar-header">
          <!-- <img class="avatar" src="https://i.loli.net/2021/03/19/6Qw2J4j1K8n3v5A.png" alt="avatar"> -->
          <!-- <div class="username">{{ userName }}</div> -->
        </div>
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          background-color="#2a91ff"
          text-color="#fff"
          active-text-color="#fff"
          @select="handleMenuSelect"
        >
          <el-menu-item index="1">
            <i class="menu-icon el-icon-s-home"></i>
            <span>简介</span>
          </el-menu-item>
          <el-submenu index="2" @click.native="loadCourseCategories">
            <template slot="title">
              <i class="menu-icon el-icon-reading"></i>
              <span>课程</span>
            </template>
            <el-menu-item 
              v-for="(category, index) in courseCategories" 
              :key="category.id"
              :index="`2-${index + 1}`"
              :disabled="category.id !== 1"
              :class="{ 'locked-course': category.id !== 1 }"
              @click="handleCourseClick(category, index)"
            >
              <i :class="getSubmenuIcon(index)"></i>
              <span>{{ category.name }}</span>
              <i v-if="category.id !== 1" class="el-icon-lock lock-icon"></i>
            </el-menu-item>
            <el-menu-item v-if="courseCategoriesLoading" index="loading">
              <i class="el-icon-loading"></i>
              <span>加载中...</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="3">
            <i class="menu-icon el-icon-user-solid"></i>
            <span>个人中心</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <!-- 右侧内容 -->
      <el-main class="main-content">
        <!-- 课程视频列表 -->
        <CourseContent
          v-if="currentCourse"
          :current-course="currentCourse"
          :course-type="activeMenu"
        />
        
        <!-- 去缴费页面 -->
        <div v-else-if="currentCourseIntro && currentCourseIntro.startsWith('payment-')">
          <div class="payment-page">
            <div class="payment-header">
              <h2>{{ getCurrentCategoryName() }}课程</h2>
              <p>您已成功报名，请完成缴费后开始学习</p>
            </div>
            
            <div class="payment-content">
              <div class="payment-info">
                <div class="info-item">
                  <span class="label">课程名称：</span>
                  <span class="value">{{ getCurrentCategoryName() }}</span>
                </div>
                <div class="info-item">
                  <span class="label">报名状态：</span>
                  <span class="value status-pending">待缴费</span>
                </div>
                <div class="info-item">
                  <span class="label">缴费金额：</span>
                  <span class="value price">￥{{ getCoursePrice() }}</span>
                </div>
              </div>
              
              <div class="payment-actions">
                <el-button type="primary" size="large" @click="goToOrders">
                  <i class="el-icon-money"></i>
                  去缴费
                </el-button>
                <!-- <el-button size="large" @click="goToOrders">
                  <i class="el-icon-document"></i>
                  去缴费
                </el-button> -->
              </div>
            </div>
          </div>
        </div>
        
        <!-- 新增：课程介绍 -->
        <div v-else-if="currentCourseIntro === 'intro-1'">
          <div class="course-header">
            <h2>{{ courseCategories[0]?.name || '初级咨询师' }}课程介绍</h2>
            
            <!-- 课程介绍标题后的报名按钮 -->
            <div class="signup-button-container">
              <el-button 
                type="primary" 
                size="large"
                @click="(courseCategories[0]?.status === 1) ? goToPayment() : showSignupDialog('2-1')"
                class="signup-button"
              >
                {{ (courseCategories[0]?.status === 1) ? '去缴费' : '报名' }}
              </el-button>
            </div>
          </div>
          
          <p>本课程为心理咨询师入门课程，包含理论基础和实践技能，适合初学者。</p>
          
          <!-- 视频列表加载状态 -->
          <div v-if="!courseData['2-1'].videos || courseData['2-1'].videos.length === 0" class="loading-state">
            <i class="el-icon-loading"></i>
            <p>正在加载视频列表...</p>
          </div>
          
          <div v-else class="video-list">
            <div 
              v-for="video in courseData['2-1'].videos" 
              :key="video.id" 
              class="video-card"
              :class="{ 'locked-video': courseCategories[0]?.status < 2 }"
              @click="handleVideoClick(video, courseCategories[0]?.status)"
            >
              <div class="video-thumb-container">
                <img :src="video.img" :alt="video.title" class="video-thumb" />
                <div v-if="courseCategories[0]?.status < 2" class="lock-overlay">
                  <i class="el-icon-lock lock-icon-large"></i>
                </div>
              </div>
              <div class="video-title">{{ video.title }}</div>
              <div class="video-intro">{{ video.intro }}</div>
            </div>
          </div>
          
          <!-- 视频列表后的报名按钮 -->
          <div class="signup-button-container">
            <el-button 
              type="primary" 
              size="large"
              @click="(courseCategories[0]?.status === 1) ? goToPayment() : showSignupDialog('2-1')"
              class="signup-button"
            >
              {{ (courseCategories[0]?.status === 1) ? '去缴费' : '报名' }}
            </el-button>
          </div>
          
          <!-- 报名对话框保持不变 -->
          <el-dialog :visible="signupDialogVisible && signupCourseType === '2-1'" title="报名信息" width="500px" @close="signupDialogVisible = false" 
           :modal-append-to-body="false" class="signup-dialog-center-title">
            <el-form :model="signupForm" :rules="signupRules" ref="signupFormRef" label-width="100px">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="signupForm.name" placeholder="请输入姓名" />
              </el-form-item>
              <el-form-item label="电话" prop="mobile">
                <el-input v-model="signupForm.mobile" placeholder="请输入手机号" :disabled="true" />
              </el-form-item>
              <el-form-item label="身份证号" prop="cardNum">
                <el-input v-model="signupForm.cardNum" placeholder="请输入身份证号码" />
              </el-form-item>
              <el-form-item label="工作单位" prop="unitName">
                <el-input v-model="signupForm.unitName" placeholder="请输入工作单位" />
              </el-form-item>
              
              <!-- 收件信息分组 -->
              <div class="form-section-title">收件信息</div>
              <el-form-item label="收件人" prop="receiverName">
                <el-input v-model="signupForm.receiverName" placeholder="请输入收件人姓名" />
              </el-form-item>
              <el-form-item label="收件手机号" prop="receiverMobile">
                <el-input v-model="signupForm.receiverMobile" placeholder="请输入收件人手机号" />
              </el-form-item>
              <el-form-item label="收货地址" prop="receiver_address">
                <el-input v-model="signupForm.receiver_address" type="textarea" :rows="2" placeholder="请输入详细收货地址" />
              </el-form-item>
              <div class="signup-tip-left">收件信息用于收取纸质证书，预计三月内发出，邮寄快递为到付。</div>
              
              <!-- 发票信息分组 -->
              <div class="form-section-title">发票信息</div>
              <el-form-item label="发票内容" prop="invoiceDetail">
                <el-input v-model="signupForm.invoiceDetail" placeholder="培训费" readonly />
              </el-form-item>
              <el-form-item label="发票类型" prop="invoiceType">
                <el-select v-model="signupForm.invoiceType" placeholder="请选择发票类型" style="width: 100%" @change="handleInvoiceTypeChange">
                  <el-option label="企业发票" value="企业发票"></el-option>
                  <el-option label="非企业发票" value="非企业发票"></el-option>
                  <el-option label="个人发票" value="个人发票"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票抬头" prop="invoiceTitle">
                <el-input v-model="signupForm.invoiceTitle" placeholder="请输入发票抬头" />
              </el-form-item>
              <el-form-item label="税号" prop="taxNumber" v-show="signupForm.invoiceType !== '个人发票'" :required="signupForm.invoiceType !== '个人发票'">
                <el-input v-model="signupForm.taxNumber" placeholder="请输入税号" />
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="signupForm.email" placeholder="请输入邮箱地址" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="signupDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitSignup">提交报名</el-button>
            </div>
          </el-dialog>
        </div>
        <div v-else-if="currentCourseIntro === 'intro-2'">
          <div class="course-header">
            <h2>{{ courseCategories[1]?.name || '中级咨询师' }}课程介绍</h2>
            
            <!-- 课程介绍标题后的报名按钮 -->
            <div class="signup-button-container">
              <el-button 
                type="primary" 
                size="large"
                @click="(courseCategories[1]?.status === 1) ? goToPayment() : showSignupDialog('2-2')"
                class="signup-button"
              >
                {{ (courseCategories[1]?.status === 1) ? '去缴费' : '报名' }}
              </el-button>
            </div>
          </div>
          
          <p>本课程深入学习心理咨询技术和案例分析，适合有一定基础的学员。</p>
          
          <!-- 视频列表加载状态 -->
          <div v-if="!courseData['2-2'].videos || courseData['2-2'].videos.length === 0" class="loading-state">
            <i class="el-icon-loading"></i>
            <p>正在加载视频列表...</p>
          </div>
          
          <div v-else class="video-list">
            <div v-for="video in courseData['2-2'].videos" :key="video.id" class="video-card">
              <img :src="video.img" :alt="video.title" class="video-thumb" />
              <div class="video-title">{{ video.title }}</div>
              <div class="video-intro">{{ video.intro }}</div>
            </div>
          </div>
          
          <!-- 视频列表后的报名按钮 -->
          <div class="signup-button-container">
            <el-button 
              type="primary" 
              size="large"
              @click="(courseCategories[1]?.status === 1) ? goToPayment() : showSignupDialog('2-2')"
              class="signup-button"
            >
              {{ (courseCategories[1]?.status === 1) ? '去缴费' : '报名' }}
            </el-button>
          </div>
          
          <!-- 报名对话框保持不变 -->
          <el-dialog :visible="signupDialogVisible && signupCourseType === '2-2'" title="报名信息" width="500px" @close="signupDialogVisible = false" 
           :modal-append-to-body="false" class="signup-dialog-center-title">
            <el-form :model="signupForm" :rules="signupRules" ref="signupFormRef" label-width="100px">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="signupForm.name" placeholder="请输入姓名" />
              </el-form-item>
              <el-form-item label="电话" prop="mobile">
                <el-input v-model="signupForm.mobile" placeholder="请输入手机号" :disabled="true" />
              </el-form-item>
              <el-form-item label="身份证号" prop="cardNum">
                <el-input v-model="signupForm.cardNum" placeholder="请输入身份证号码" />
              </el-form-item>
              <el-form-item label="工作单位" prop="unitName">
                <el-input v-model="signupForm.unitName" placeholder="请输入工作单位" />
              </el-form-item>
              
              <!-- 收件信息分组 -->
              <div class="form-section-title">收件信息</div>
              <el-form-item label="收件人" prop="receiverName">
                <el-input v-model="signupForm.receiverName" placeholder="请输入收件人姓名" />
              </el-form-item>
              <el-form-item label="收件手机号" prop="receiverMobile">
                <el-input v-model="signupForm.receiverMobile" placeholder="请输入收件人手机号" />
              </el-form-item>
              <el-form-item label="收货地址" prop="receiver_address">
                <el-input v-model="signupForm.receiver_address" type="textarea" :rows="2" placeholder="请输入详细收货地址" />
              </el-form-item>
              <div class="signup-tip-left">收件信息用于收取纸质证书，预计三月内发出，邮寄快递为到付。</div>
              
              <!-- 发票信息分组 -->
              <div class="form-section-title">发票信息</div>
              <el-form-item label="发票内容" prop="invoiceDetail">
                <el-input v-model="signupForm.invoiceDetail" placeholder="培训费" readonly />
              </el-form-item>
              <el-form-item label="发票类型" prop="invoiceType">
                <el-select v-model="signupForm.invoiceType" placeholder="请选择发票类型" style="width: 100%" @change="handleInvoiceTypeChange">
                  <el-option label="企业发票" value="企业发票"></el-option>
                  <el-option label="非企业发票" value="非企业发票"></el-option>
                  <el-option label="个人发票" value="个人发票"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票抬头" prop="invoiceTitle">
                <el-input v-model="signupForm.invoiceTitle" placeholder="请输入发票抬头" />
              </el-form-item>
              <el-form-item label="税号" prop="taxNumber" v-show="signupForm.invoiceType !== '个人发票'" :required="signupForm.invoiceType !== '个人发票'">
                <el-input v-model="signupForm.taxNumber" placeholder="请输入税号" />
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="signupForm.email" placeholder="请输入邮箱地址" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="signupDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitSignup">提交报名</el-button>
            </div>
          </el-dialog>
        </div>
        <div v-else-if="currentCourseIntro === 'intro-3'">
          <div class="course-header">
            <h2>{{ courseCategories[2]?.name || '高级咨询师' }}课程介绍</h2>
            
            <!-- 课程介绍标题后的报名按钮 -->
            <div class="signup-button-container">
              <el-button 
                type="primary" 
                size="large"
                @click="(courseCategories[2]?.status === 1) ? goToPayment() : showSignupDialog('2-3')"
                class="signup-button"
              >
                {{ (courseCategories[2]?.status === 1) ? '去缴费' : '报名' }}
              </el-button>
            </div>
          </div>
          
          <p>本课程涵盖高级心理咨询技术和督导技能培训，适合提升专业能力。</p>
          
          <!-- 视频列表加载状态 -->
          <div v-if="!courseData['2-3'].videos || courseData['2-3'].videos.length === 0" class="loading-state">
            <i class="el-icon-loading"></i>
            <p>正在加载视频列表...</p>
          </div>
          
          <div v-else class="video-list">
            <div v-for="video in courseData['2-3'].videos" :key="video.id" class="video-card">
              <img :src="video.img" :alt="video.title" class="video-thumb" />
              <div class="video-title">{{ video.title }}</div>
              <div class="video-intro">{{ video.intro }}</div>
            </div>
          </div>
          
          <!-- 视频列表后的报名按钮 -->
          <div class="signup-button-container">
            <el-button 
              type="primary" 
              size="large"
              @click="(courseCategories[2]?.status === 1) ? goToPayment() : showSignupDialog('2-3')"
              class="signup-button"
            >
              {{ (courseCategories[2]?.status === 1) ? '去缴费' : '报名' }}
            </el-button>
          </div>
          
          <!-- 报名对话框保持不变 -->
          <el-dialog :visible="signupDialogVisible && signupCourseType === '2-3'" title="报名信息" width="500px" @close="signupDialogVisible = false" 
           :modal-append-to-body="false" class="signup-dialog-center-title">
            <el-form :model="signupForm" :rules="signupRules" ref="signupFormRef" label-width="100px">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="signupForm.name" placeholder="请输入姓名" />
              </el-form-item>
              <el-form-item label="电话" prop="mobile">
                <el-input v-model="signupForm.mobile" placeholder="请输入手机号"  :disabled="true"/>
              </el-form-item>
              <el-form-item label="身份证号" prop="cardNum">
                <el-input v-model="signupForm.cardNum" placeholder="请输入身份证号码" />
              </el-form-item>
              <el-form-item label="工作单位" prop="unitName">
                <el-input v-model="signupForm.unitName" placeholder="请输入工作单位" />
              </el-form-item>
              
              <!-- 收件信息分组 -->
              <div class="form-section-title">收件信息</div>
              <el-form-item label="收件人" prop="receiverName">
                <el-input v-model="signupForm.receiverName" placeholder="请输入收件人姓名" />
              </el-form-item>
              <el-form-item label="收件手机号" prop="receiverMobile">
                <el-input v-model="signupForm.receiverMobile" placeholder="请输入收件人手机号" />
              </el-form-item>
              <el-form-item label="收货地址" prop="receiver_address">
                <el-input v-model="signupForm.receiver_address" type="textarea" :rows="2" placeholder="请输入详细收货地址" />
              </el-form-item>
              <div class="signup-tip-left">收件信息用于收取纸质证书，预计三月内发出，邮寄快递为到付。</div>
              
              <!-- 发票信息分组 -->
              <div class="form-section-title">发票信息</div>
              <el-form-item label="发票内容" prop="invoiceDetail">
                <el-input v-model="signupForm.invoiceDetail" placeholder="培训费" readonly />
              </el-form-item>
              <el-form-item label="发票类型" prop="invoiceType">
                <el-select v-model="signupForm.invoiceType" placeholder="请选择发票类型" style="width: 100%" @change="handleInvoiceTypeChange">
                  <el-option label="企业发票" value="企业发票"></el-option>
                  <el-option label="非企业发票" value="非企业发票"></el-option>
                  <el-option label="个人发票" value="个人发票"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票抬头" prop="invoiceTitle">
                <el-input v-model="signupForm.invoiceTitle" placeholder="请输入发票抬头" />
              </el-form-item>
              <el-form-item label="税号" prop="taxNumber" v-show="signupForm.invoiceType !== '个人发票'" :required="signupForm.invoiceType !== '个人发票'">
                <el-input v-model="signupForm.taxNumber" placeholder="请输入税号" />
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="signupForm.email" placeholder="请输入邮箱地址" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="signupDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitSignup">提交报名</el-button>
            </div>
          </el-dialog>
        </div>
        <div v-else-if="currentCourseIntro === 'intro-4'">
          <div class="course-header">
            <h2>{{ courseCategories[3]?.name || '督导师' }}课程介绍</h2>
            
            <!-- 课程介绍标题后的报名按钮 -->
            <div class="signup-button-container">
              <el-button 
                type="primary" 
                size="large"
                @click="(courseCategories[3]?.status === 1) ? goToPayment() : showSignupDialog('2-4')"
                class="signup-button"
              >
                {{ (courseCategories[3]?.status === 1) ? '去缴费' : '报名' }}
              </el-button>
            </div>
          </div>
          
          <p>本课程为心理咨询督导师认证课程，提升督导与管理能力。</p>
          
          <!-- 视频列表加载状态 -->
          <div v-if="!courseData['2-4'].videos || courseData['2-4'].videos.length === 0" class="loading-state">
            <i class="el-icon-loading"></i>
            <p>正在加载视频列表...</p>
          </div>
          
          <div v-else class="video-list">
            <div v-for="video in courseData['2-4'].videos" :key="video.id" class="video-card">
              <img :src="video.img" :alt="video.title" class="video-thumb" />
              <div class="video-title">{{ video.title }}</div>
              <div class="video-intro">{{ video.intro }}</div>
            </div>
          </div>
          
          <!-- 视频列表后的报名按钮 -->
          <div class="signup-button-container">
            <el-button 
              type="primary" 
              size="large"
              @click="(courseCategories[3]?.status === 1) ? goToPayment() : showSignupDialog('2-4')"
              class="signup-button"
            >
              {{ (courseCategories[3]?.status === 1) ? '去缴费' : '报名' }}
            </el-button>
          </div>
          
          <!-- 报名对话框保持不变 -->
          <el-dialog :visible="signupDialogVisible && signupCourseType === '2-4'" title="报名信息" width="500px" @close="signupDialogVisible = false" 
           :modal-append-to-body="false" class="signup-dialog-center-title">
            <el-form :model="signupForm" :rules="signupRules" ref="signupFormRef" label-width="100px">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="signupForm.name" placeholder="请输入姓名" />
              </el-form-item>
              <el-form-item label="电话" prop="mobile">
                <el-input v-model="signupForm.mobile" placeholder="请输入手机号" />
              </el-form-item>
              <el-form-item label="身份证号" prop="cardNum">
                <el-input v-model="signupForm.cardNum" placeholder="请输入身份证号码" />
              </el-form-item>
              <el-form-item label="工作单位" prop="unitName">
                <el-input v-model="signupForm.unitName" placeholder="请输入工作单位" />
              </el-form-item>
              
              <!-- 收件信息分组 -->
              <div class="form-section-title">收件信息</div>
              <el-form-item label="收件人" prop="receiverName">
                <el-input v-model="signupForm.receiverName" placeholder="请输入收件人姓名" />
              </el-form-item>
              <el-form-item label="收件手机号" prop="receiverMobile">
                <el-input v-model="signupForm.receiverMobile" placeholder="请输入收件人手机号" />
              </el-form-item>
              <el-form-item label="收货地址" prop="receiver_address">
                <el-input v-model="signupForm.receiver_address" type="textarea" :rows="2" placeholder="请输入详细收货地址" />
              </el-form-item>
              <div class="signup-tip-left">收件信息用于收取纸质证书，预计三月内发出，邮寄快递为到付。</div>
              
              <!-- 发票信息分组 -->
              <div class="form-section-title">发票信息</div>
              <el-form-item label="发票内容" prop="invoiceDetail">
                <el-input v-model="signupForm.invoiceDetail" placeholder="培训费" readonly />
              </el-form-item>
              <el-form-item label="发票类型" prop="invoiceType">
                <el-select v-model="signupForm.invoiceType" placeholder="请选择发票类型" style="width: 100%" @change="handleInvoiceTypeChange">
                  <el-option label="企业发票" value="企业发票"></el-option>
                  <el-option label="非企业发票" value="非企业发票"></el-option>
                  <el-option label="个人发票" value="个人发票"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票抬头" prop="invoiceTitle">
                <el-input v-model="signupForm.invoiceTitle" placeholder="请输入发票抬头" />
              </el-form-item>
              <el-form-item label="税号" prop="taxNumber" v-show="signupForm.invoiceType !== '个人发票'" :required="signupForm.invoiceType !== '个人发票'">
                <el-input v-model="signupForm.taxNumber" placeholder="请输入税号" />
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="signupForm.email" placeholder="请输入邮箱地址" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="signupDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="submitSignup">提交报名</el-button>
            </div>
          </el-dialog>
        </div>

        <!-- 个人中心 - 我的订单 -->
        <PersonalCenter
          v-else-if="activeMenu === '3'"
          @pay-order="payOrder"
          @continue-study="continueStudy"
          @view-certificate="viewCertificate"
          @view-order-detail="viewOrderDetail"
          @register-course="registerCourse"
          ref="personalCenter"
        />

        <!-- 默认简介页面 -->
        <IntroductionContent v-else />
        
        <!-- 支付二维码弹窗（新） -->
        <el-dialog 
          title="" 
          :visible.sync="qrCodeDialogVisible" 
          width="500px" 
          center 
          :show-close="false"
          custom-class="payment-dialog"
          :modal-append-to-body="false"
          :append-to-body="false"
        >
          <div class="wrap">
            <div class="card">
              <div class="brand">
                <img class="logo" :src="payLogo" alt="logo" />
                <div class="title">中国心理卫生协会</div>
              </div>
              <p class="subtitle">支持微信，支付宝，云闪付等钱包扫码支付</p>
              <div class="status">
                <span class="dot"></span>
                <span>等待支付中</span>
              </div>
              <div class="qrcode-box">
                <img :src="qrImageFullUrl" alt="支付二维码" style="width:260px;height:260px;border-radius:8px;border:1px solid #eee;" />
              </div>
              <div class="meta">
                <div class="row">
                  <span class="key" style="font-size:20px">支付金额：</span>
                  <span style="font-weight:600;color:#111827;font-size:25px">￥{{ currentPaymentAmount }}</span>
                </div>
              </div>
              <div class="actions">
                <button class="btn" @click="goToOrders">取消支付</button>
                <button class="btn primary" @click="goToOrders">已完成支付</button>
              </div>
              <div class="tips">若已支付成功，请点击"已完成支付"返回订单页查看状态</div>
            </div>
          </div>
        </el-dialog>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Topbar from '@/components/Topbar.vue'
import IntroductionContent from '@/components/IntroductionContent.vue'
import CourseContent from '@/components/CourseContent.vue'
import PersonalCenter from '@/components/PersonalCenter.vue'
import { get } from '@/common/request.js'
import PayLogo from '@/assets/img/微信图片_20250324134230.jpg'

export default {
  name: 'Notice',
  components: {
    Topbar,
    IntroductionContent,
    CourseContent,
    PersonalCenter
  },
  data() {
    return {
      activeMenu: '1',
      currentCourse: null,
      currentCourseIntro: null,
      // 课程分类数据
      courseCategories: [],
      // 课程数据映射
      courseDataMap: {},
      // 课程分类加载状态
      courseCategoriesLoading: false,

      courseData: {},
      notices: [],
      // 订单数据
      orders: [],
      userName: '',
      userLevels: {},
      signupDialogVisible: false,
      signupCourseType: '',
      signupForm: {
        name: '',
        mobile: localStorage.getItem('login_mobile') || '',
        cardNum: '',
        unitName: '',
        receiverName: '',
        receiverMobile: '',
        receiver_address: '',
        invoiceDetail: '培训费',
        invoiceType: '',
        invoiceTitle: '',
        taxNumber: '',
        email: ''
      },
      signupRules: {
        name: [ { required: true, message: '请输入姓名', trigger: 'blur' } ],
        mobile: [ { required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' } ],
        cardNum: [ { required: true, message: '请输入身份证号码', trigger: 'blur' } ],
        unitName: [ { required: true, message: '请输入工作单位', trigger: 'blur' } ],
        receiverName: [ { required: true, message: '请输入收件人姓名', trigger: 'blur' } ],
        receiverMobile: [ { required: true, message: '请输入收件人手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' } ],
        receiver_address: [ { required: true, message: '请输入收货地址', trigger: 'blur' } ],
        invoiceDetail: [],
        invoiceType: [ { required: true, message: '请选择发票类型', trigger: 'change' } ],
        invoiceTitle: [ { required: true, message: '请输入发票抬头', trigger: 'blur' } ],
        taxNumber: [ 
          { 
            validator: (rule, value, callback) => {
              if (this.signupForm.invoiceType !== '个人发票' && !value) {
                callback(new Error('请输入税号'))
              } else {
                callback()
              }
            }, 
            trigger: 'blur' 
          } 
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      },
      // 支付二维码弹窗相关
      qrCodeDialogVisible: false,
      qrImageFullUrl: '',
      currentPaymentAmount: 0,
      payLogo: PayLogo
    }
  },
  async mounted() {
    await this.loginByMobile();
    
    // 等待登录完成（token就绪）后再获取用户信息
    // 通过监听token变化或等待一段时间来确保登录完成
    await this.waitForToken();
    
    // 获取用户信息（登录后）
    if (this.$store.state.token) {
      await this.getUserInfo();
    }
    // 获取订单数据
    await this.loadOrders();
    
    // 处理路由参数
    this.handleRouteParams();
  },
  
  methods: {
    // 等待token就绪（登录完成）
    async waitForToken() {
      // 检查登录是否正在进行中（通过sessionStorage标记）
      const isLoggingIn = sessionStorage.getItem('logging_in') === '1';
      
      // 如果登录正在进行中，等待登录完成
      if (isLoggingIn) {
        const maxWait = 5000; // 最多等待5秒
        const checkInterval = 100;
        let waited = 0;
        
        while (waited < maxWait) {
          // 检查登录是否完成（登录完成后会清除标记）
          if (sessionStorage.getItem('logging_in') !== '1') {
            break;
          }
          await new Promise(resolve => setTimeout(resolve, checkInterval));
          waited += checkInterval;
        }
      }
      
      // 如果已经有token，直接返回
      if (this.$store.state.token || localStorage.getItem('token')) {
        return;
      }
      
      // 如果没有token，等待token就绪，最多等待3秒
      const maxWait = 3000;
      const checkInterval = 100;
      let waited = 0;
      
      while (waited < maxWait) {
        if (this.$store.state.token || localStorage.getItem('token')) {
          return;
        }
        await new Promise(resolve => setTimeout(resolve, checkInterval));
        waited += checkInterval;
      }
    },
    // 处理路由参数
    handleRouteParams() {
      const { tab, orderTab } = this.$route.query
      
      if (tab === 'personal') {
        // 显示个人中心
        this.activeMenu = '3'
        
        // 如果有orderTab参数，传递给PersonalCenter组件
        if (orderTab) {
          this.$nextTick(() => {
            // 通过ref调用PersonalCenter组件的方法
            if (this.$refs.personalCenter) {
              this.$refs.personalCenter.setActiveOrderTab(orderTab)
            }
          })
        }
      }
    },
    goToLearning() {
      this.$router.push('/learning')
    },
    async handleMenuSelect(index) {
      this.activeMenu = index;
      this.currentCourse = null;
      this.currentCourseIntro = null;

      // 课程权限判断
      if (index.startsWith('2-')) {
        // 如果课程分类还没有加载，先加载
        if (this.courseCategories.length === 0) {
          await this.loadCourseCategories();
            // 加载完成后重新处理菜单选择
          await this.handleMenuSelect(index);
          return;
        }
        
        // 如果正在加载，等待加载完成
        if (this.courseCategoriesLoading) {
          await new Promise(resolve => setTimeout(resolve, 100));
          await this.handleMenuSelect(index);
          return;
        }
        
        const courseIndex = parseInt(index.split('-')[1]) - 1;
        const category = this.courseCategories[courseIndex];
        
        if (category) {
          // 无论什么状态都先调用getVideoList获取视频列表
          await this.getVideoList(category.id, index);
          
          if (category.status === 0) {
            // status = 0：显示报名页面，但视频列表已加载
            this.currentCourseIntro = `intro-${courseIndex + 1}`;
          } else if (category.status === 1) {
            // status = 1：显示课程介绍，但按钮为去缴费，视频列表已加载
            this.currentCourseIntro = `intro-${courseIndex + 1}`;
          } else if (category.status >= 2) {
            // status >= 2：显示视频页面
            this.currentCourse = this.courseData[index];
          }
        }
      } else {
        this.currentCourse = null;
        this.currentCourseIntro = null;
      }
    },

    // 处理课程点击事件
    async handleCourseClick(category, index) {
      // 只有初级咨询师（id=1）可以点击
      if (category.id === 1) {
        // 先调用handleMenuSelect获取视频列表
        await this.handleMenuSelect(`2-${index + 1}`);
        
        // 如果用户已经报名缴费（status >= 2），检查第一个视频的解锁状态
        if (category.status >= 2) {
          const courseKey = `2-${index + 1}`;
          const courseData = this.courseData[courseKey];
          
          if (courseData && courseData.videos && courseData.videos.length > 0) {
            const firstVideo = courseData.videos[0];
            
            // 检查第一个视频是否已解锁
            if (!firstVideo.unlocked) {
              try {
                // 调用解锁接口，使用GET方法，id放在URL上
                const response = await this.$http.get(`/api.php/v1.video/unlock?id=${firstVideo.id}`);
                
                if (response.data && response.data.code === 0) {
                  // 解锁成功，更新视频状态
                  firstVideo.unlocked = true;
                  this.$message.success('视频已解锁');
                  // 重新调用视频列表接口
                  await this.getVideoList(category.id, courseKey);
                } else {
                  console.error('解锁视频失败:', response.data?.msg || '未知错误');
                }
              } catch (error) {
                console.error('解锁视频失败:', error);
              }
            }
          }
        }
      } else {
        this.$message.warning('该课程暂未开放，敬请期待！');
      }
    },


    // 支付订单：调用后端生成支付二维码
    async payOrder(order) {
      try {
        // 弹确认框
        await this.$confirm(`确认支付订单 ${order.orderNumber}？`, '支付确认', {
          confirmButtonText: '确定支付',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const formData = new FormData()
        formData.append('cid', order.cid)
        formData.append('orderNum', order.orderNumber)

        const res = await this.$http.post('/api.php/v1.user/doUnionPay', formData)
        if (!res || !res.data) {
          this.$message.error('发起支付失败')
          return
        }

        // 后端可能直接返回字符串或包在 data 里
        let qrPath = ''
        if (typeof res.data === 'string') {
          qrPath = res.data
        } else if (res.data.code === 0) {
          const d = res.data.data
          qrPath = (typeof d === 'string') ? d : (d && (d.html || d.path)) || ''
        } else if (res.data.data) {
          const d = res.data.data
          qrPath = (typeof d === 'string') ? d : (d && (d.html || d.path)) || ''
        }

        if (!qrPath) {
          this.$message.error(res.data.msg || '未获取到支付二维码')
          return
        }

        const prefix = 'https://jxjy.camh.org.cn'
        this.qrImageFullUrl = `${prefix}${qrPath}`
        this.currentPaymentAmount = order.price || this.getCoursePrice()
        this.qrCodeDialogVisible = true
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.info('已取消支付')
        }
      }
    },

    // 继续学习
    continueStudy(order) {
      // 根据订单中的课程类型跳转到学习页面
      let courseType = '2-1' // 默认第一个课程
      
      // 根据课程名称动态匹配课程类型
      const courseIndex = this.courseCategories.findIndex(category => 
        order.courseName.includes(category.name)
      );
      
      if (courseIndex !== -1) {
        courseType = `2-${courseIndex + 1}`;
      }

      this.$router.push({
        path: '/learning',
        query: {
          courseType: courseType,
          videoId: 1
        }
      })
    },

    // 查看证书
    viewCertificate(order) {
      this.$message.success(`正在查看 ${order.courseName} 的结业证书`)
      // 这里可以打开证书查看页面或下载证书
    },

    // 查看订单详情
    viewOrderDetail(order) {
      this.$alert(`
        <div style="text-align: left;">
          <p><strong>订单号：</strong>${order.orderNumber}</p>
          <p><strong>课程名称：</strong>${order.orderName}</p>
          <p><strong>订单金额：</strong>￥${order.price}</p>
          <p><strong>创建时间：</strong>${order.createTime}</p>
          <p><strong>学习进度：</strong>${order.progress}%</p>
          <p><strong>订单状态：</strong>${order.statusText}</p>
        </div>
      `, '订单详情', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true
      })
    },

    // 报名课程
    registerCourse(order) {
      // 根据订单中的课程ID跳转到对应的报名页面
      const courseType = `2-${order.cid}`;
      this.activeMenu = courseType;
      this.handleMenuSelect(courseType);
    },
    async loginByMobile() {
      const mobile = localStorage.getItem('login_mobile');
      if (mobile) {
        // 设置默认用户名为手机号
        this.userName = mobile;
        localStorage.setItem('user_name', this.userName);
        
        // 刷新当前菜单内容
        await this.handleMenuSelect(this.activeMenu)
      } else {
        // console.warn('localStorage 未找到 login_mobile');
      }
    },

    async showSignupDialog(courseType) {
      this.signupCourseType = courseType;
      this.signupDialogVisible = true;
      
      // 先获取用户信息
      await this.getUserInfo();
    },

    // 获取用户信息
    async getUserInfo() {
      // 检查是否有token，如果没有token（登录未完成），直接返回，不调用接口
      const token = this.$store.state.token || localStorage.getItem('token');
      if (!token) {
        console.log('登录未完成，跳过获取用户信息');
        return;
      }
      
      try {
        const response = await this.$http.get('/api.php/v1.user/info');
        if (response.data && response.data.code === 0) {
          const userInfo = response.data.data;
          
          // 检查返回的data是否为空（null、undefined、空对象）
          const isEmpty = 
            userInfo === null || 
            userInfo === undefined || 
            (userInfo && typeof userInfo === 'object' && Object.keys(userInfo).length === 0);
          
          if (isEmpty) {
            console.log('用户信息接口返回空数据，准备刷新页面:', userInfo);
            try {
              // 获取当前刷新次数
              const reloadCount = parseInt(sessionStorage.getItem('reload_count_userinfo') || '0', 10);
              
              // 最多刷新5次
              if (reloadCount < 5) {
                // 增加刷新次数
                sessionStorage.setItem('reload_count_userinfo', String(reloadCount + 1));
                console.log(`开始刷新页面... (第 ${reloadCount + 1} 次)`);
                setTimeout(() => { window.location.reload(); }, 50);
                return;
              } else {
                console.log('已达到最大刷新次数(5次)，停止刷新');
                // 清除刷新计数，避免影响后续
                sessionStorage.removeItem('reload_count_userinfo');
              }
            } catch (e) {
              console.error('刷新页面时出错:', e);
              // 忽略 sessionStorage 不可用等异常
            }
          } else {
            // 如果数据不为空，清除刷新计数
            try {
              sessionStorage.removeItem('reload_count_userinfo');
            } catch (e) {
              // 忽略异常
            }
          }
          
          // 更新表单数据
          this.signupForm = {
            name: userInfo.name || '',
            mobile: userInfo.phone || localStorage.getItem('login_mobile') || '',
            cardNum: userInfo.card_num || '',
            unitName: userInfo.unit_name || '',
            receiverName: userInfo.receiver_name || '',
            receiverMobile: userInfo.receiver_mobile || '',
            receiver_address: userInfo.receiver_address || '',
            invoiceDetail: userInfo.invoice_detail || '',
            invoiceType: userInfo.invoice_type || '',
            invoiceTitle: userInfo.invoice_title || '',
            taxNumber: userInfo.tax_number || '',
            email: userInfo.email || ''
          };
        } else {
          // 如果获取用户信息失败，使用默认值
          this.signupForm = {
            name: '',
            mobile: localStorage.getItem('login_mobile') || '',
            cardNum: '',
            unitName: '',
            receiverName: '',
            receiverMobile: '',
            receiver_address: '',
            invoiceDetail: '培训费',
            invoiceType: '',
            invoiceTitle: '',
            taxNumber: '',
            email: ''
          };
          console.warn('获取用户信息失败:', response.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 使用默认值
        this.signupForm = {
          name: '',
          mobile: localStorage.getItem('login_mobile') || '',
          cardNum: '',
          unitName: '',
          receiverName: '',
          receiverMobile: '',
          receiver_address: '',
          invoiceDetail: '培训费',
          invoiceType: '',
          invoiceTitle: '',
          taxNumber: '',
          email: ''
        };
      }
    },
    // 加载课程分类
    async loadCourseCategories() {
      // 如果已经加载过，就不再重复加载
      if (this.courseCategories.length > 0) {
        return;
      }
      
      // 如果正在加载，直接返回
      if (this.courseCategoriesLoading) {
        return;
      }
      
      // 检查是否有token
      const token = this.$store.state.token;
      if (!token) {
        console.log('等待token就绪...');
        return;
      }
      
      this.courseCategoriesLoading = true;
      
      try {
        const response = await get('/api.php/v1.video/category');
        if (response.data && response.data.code === 0) {
          this.courseCategories = response.data.data;
          this.updateCourseDataMap();
        } else {
          console.error('获取课程分类失败:', response.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取课程分类失败:', error);
      } finally {
        this.courseCategoriesLoading = false;
      }
    },

    // 获取课程分类（保留原方法名以兼容）
    async getCourseCategories() {
      await this.loadCourseCategories();
    },

    // 更新课程数据映射
    updateCourseDataMap() {
      this.courseCategories.forEach((category, index) => {
        const courseKey = `2-${index + 1}`;
        // 动态创建课程数据结构
        this.courseData[courseKey] = {
          level: category.name,
          status: category.status,
          cid: category.id,
          videos: [],
          test: {}
        };
      });
    },

    // 获取视频列表
    async getVideoList(cid, courseKey) {
      try {
        const response = await get(`/api.php/v1.video/lists?cid=${cid}`);
        if (response.data && response.data.code === 0) {
          const payload = response.data.data || {};
          const videoData = Array.isArray(payload.video) ? payload.video : [];
          const examData = Array.isArray(payload.exam) ? payload.exam : [];
          
          // 更新课程数据中的视频信息
          if (this.courseData[courseKey]) {
            this.courseData[courseKey].videos = videoData.map(video => ({
              id: video.id,
              title: video.title,
              img: video.image,
              videoUrl: video.url,
              intro: video.intro,
              unlocked: video.unlock === 1, // 修正：使用unlock字段
              sort: video.sort
            }));
            
            // 解析考试权限：exam是数组，按cid查找对应的解锁状态
            const testUnlocked = {};
            examData.forEach(examItem => {
              if (examItem && typeof examItem.cid !== 'undefined') {
                testUnlocked[examItem.cid] = examItem.unlock === 1; // 修正：使用unlock字段
              }
            });
            this.courseData[courseKey].test = testUnlocked;
            
            // 添加课程类型标识
            this.courseData[courseKey].courseType = courseKey;
          }
          
          // 同时更新store中的课程数据
          this.updateStoreCourseData(courseKey, videoData);
        } else {
          console.error('获取视频列表失败:', response.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取视频列表失败:', error);
      }
    },

    // 更新store中的课程数据
    updateStoreCourseData(courseKey, videoData) {
      // 将courseKey转换为store中使用的格式
      const storeCourseKey = courseKey;
      
      // 更新store中的课程数据
      this.$store.commit('updateCourseVideos', {
        courseType: storeCourseKey,
        videos: videoData.map(video => ({
          id: video.id,
          title: video.title,
          img: video.image,
          type: 'video',
          videoUrl: video.url,
          unlocked: video.unlock === 1, // 修正：使用unlock字段
          sort: video.sort
        }))
      });
      
      // 同时创建课程类型数据
      this.$store.commit('updateCourseType', {
        courseType: storeCourseKey,
        name: this.courseData[courseKey]?.level || '未知课程'
      });
    },

    // 获取子菜单图标
    getSubmenuIcon(index) {
      const icons = [
        'submenu-icon el-icon-medal-1',
        'submenu-icon el-icon-trophy-1',
        'submenu-icon el-icon-star-on',
        'submenu-icon el-icon-user'
      ];
      return icons[index] || 'submenu-icon el-icon-reading';
    },

    async submitSignup() {
      this.$refs.signupFormRef.validate(async (valid) => {
        if (valid) {
          try {
            // 获取课程分类ID
            const courseIndex = parseInt(this.signupCourseType.split('-')[1]) - 1;
            const category = this.courseCategories[courseIndex];
            if (!category) {
              this.$message.error('课程信息获取失败');
              return;
            }

            // 创建FormData对象
            const formData = new FormData();
            formData.append('cid', category.id);
            formData.append('realname', this.signupForm.name);
            formData.append('phone', this.signupForm.mobile);
            formData.append('cardnum', this.signupForm.cardNum);
            formData.append('unitname', this.signupForm.unitName);
            formData.append('receiver_name', this.signupForm.receiverName);
            formData.append('receiver_mobile', this.signupForm.receiverMobile);
            formData.append('receiver_address', this.signupForm.receiver_address);
            formData.append('invoice_detail', this.signupForm.invoiceDetail);
            formData.append('invoice_type', this.signupForm.invoiceType);
            formData.append('invoice_title', this.signupForm.invoiceTitle);
            formData.append('tax_number', this.signupForm.taxNumber);
            formData.append('email', this.signupForm.email);

            const res = await this.$http.post('/api.php/v1.user/apply', formData);
            
            if (res.data && res.data.code === 0) {
              this.$message.success('报名成功！');
              this.signupDialogVisible = false;
              
              // 报名成功后，显示确认对话框，询问是否去支付
              this.$confirm('报名成功！是否前往支付页面？', '提示', {
                confirmButtonText: '去支付',
                cancelButtonText: '稍后支付',
                type: 'success'
              }).then(() => {
                // 用户选择去支付，跳转到我的订单页面
                this.goToOrders();
              }).catch(() => {
                // 用户选择稍后支付，不做任何操作
                console.log('用户选择稍后支付');
              });
            } else {
              this.$message.error(res.data && res.data.msg ? res.data.msg : '报名失败，请重试');
            }
          } catch (e) {
            console.error('报名失败:', e);
            this.$message.error('报名失败，请检查网络或稍后重试');
          }
        }
      });
    },

    // 显示支付弹窗
    showPaymentDialog(htmlContent) {
      // 接口返回的是二维码图片相对路径，拼接域名成为完整地址
      const prefix = 'https://jxjy.camh.org.cn';
      const path = typeof htmlContent === 'string' ? htmlContent : '';
      this.qrImageFullUrl = path ? `${prefix}${path}` : '';
      // 使用课程价格作为展示金额
      const price = this.getCoursePrice();
      this.currentPaymentAmount = price;
      this.qrCodeDialogVisible = true;
    },

    // 获取当前课程分类名称
    getCurrentCategoryName() {
      if (!this.currentCourseIntro) return '未知课程'
      
      if (this.currentCourseIntro.startsWith('payment-')) {
        const courseIndex = parseInt(this.currentCourseIntro.split('-')[1]) - 1
        return this.courseCategories[courseIndex]?.name || '未知课程'
      } else if (this.currentCourseIntro.startsWith('intro-')) {
        const courseIndex = parseInt(this.currentCourseIntro.split('-')[1]) - 1
        return this.courseCategories[courseIndex]?.name || '未知课程'
      }
      
      return '未知课程'
    },

    // 获取当前课程价格
    getCoursePrice() {
      if (!this.currentCourseIntro) return '0'
      
      let courseIndex = 0
      if (this.currentCourseIntro.startsWith('payment-')) {
        courseIndex = parseInt(this.currentCourseIntro.split('-')[1]) - 1
      } else if (this.currentCourseIntro.startsWith('intro-')) {
        courseIndex = parseInt(this.currentCourseIntro.split('-')[1]) - 1
      }
      
      // 根据课程索引获取对应的课程ID
      const courseId = courseIndex + 1
      
      // 从订单数据中查找对应课程的价格
      const order = this.orders.find(order => order.cid === courseId)
      if (order && order.price) {
        return order.price.toString()
      }
      
      // 如果没有找到订单数据，返回默认价格
      const defaultPrices = {
        0: '780', // 初级咨询师
        1: '780', // 中级咨询师
        2: '780', // 高级咨询师
        3: '780'  // 督导师
      }
      
      return defaultPrices[courseIndex] || '0'
    },

    // 跳转到支付页面
    goToPayment() {
      if (!this.currentCourseIntro) return
      
      let courseIndex = 0
      if (this.currentCourseIntro.startsWith('payment-')) {
        courseIndex = parseInt(this.currentCourseIntro.split('-')[1]) - 1
      } else if (this.currentCourseIntro.startsWith('intro-')) {
        courseIndex = parseInt(this.currentCourseIntro.split('-')[1]) - 1
      }
      
      const category = this.courseCategories[courseIndex]
      if (category) {
        // 清除当前课程状态
        this.currentCourse = null;
        this.currentCourseIntro = null;
        // 切换到个人中心视图
        this.activeMenu = '3';
        
        // 等渲染出 PersonalCenter 后设置其内部标签为待缴费
        this.$nextTick(() => {
          if (this.$refs.personalCenter && typeof this.$refs.personalCenter.setActiveOrderTab === 'function') {
            this.$refs.personalCenter.setActiveOrderTab('pending');
          }
        });
        
        // 同步 URL
        const target = { path: this.$route.path || '/', query: { tab: 'personal', orderTab: 'pending' } };
        if (this.$route.path === target.path && JSON.stringify(this.$route.query) === JSON.stringify(target.query)) {
          // 已是同一路由，也强制刷新页面
          setTimeout(() => { window.location.reload(); }, 50);
          return;
        }
        this.$router.replace(target).finally(() => {
          // 导航完成后强制刷新页面，确保订单与UI最新
          setTimeout(() => { window.location.reload(); }, 50);
        });
        
        this.$message.success('正在跳转到订单页面...')
      } else {
        this.$message.error('课程信息获取失败')
      }
    },

    // 跳转到订单列表页面
    goToOrders() {
      // 跳转到个人中心的订单页面
      this.qrCodeDialogVisible = false;
      // 确保不会被上方 v-if 分支拦截
      this.currentCourse = null;
      this.currentCourseIntro = null;
      // 直接切换到个人中心视图
      this.activeMenu = '3';
      // 等渲染出 PersonalCenter 后设置其内部标签
      this.$nextTick(() => {
        if (this.$refs.personalCenter && typeof this.$refs.personalCenter.setActiveOrderTab === 'function') {
          this.$refs.personalCenter.setActiveOrderTab('all');
        }
      });
      // 同步 URL（若已在相同路径上，用 replace 保证触发）
      const target = { path: this.$route.path || '/', query: { tab: 'personal', orderTab: 'all' } };
      if (this.$route.path === target.path && JSON.stringify(this.$route.query) === JSON.stringify(target.query)) {
        // 已是同一路由，也强制刷新页面
        setTimeout(() => { window.location.reload(); }, 50);
        return;
      }
      this.$router.replace(target).finally(() => {
        // 导航完成后强制刷新页面，确保订单与UI最新
        setTimeout(() => { window.location.reload(); }, 50);
      });
    },
    handleVideoClick(video, courseStatus) {
      if (courseStatus === 0) {
        // 未报名状态
        this.$message.warning('请先点击报名按钮报名');
      } else if (courseStatus === 1) {
        // 待支付状态
        this.$confirm('请先去支付，是否跳转到我的订单？', '提示', {
          confirmButtonText: '去支付',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 跳转到个人中心页面
          this.activeMenu = '3';
          this.currentCourse = null;
          this.currentCourseIntro = null;
        }).catch(() => {
          // 用户取消
        });
      } else if (courseStatus >= 2) {
        // 已支付状态，可以正常播放
        // 这里可以添加跳转到学习页面的逻辑
        console.log('可以播放视频:', video);
      }
    },
    // 在methods中添加获取订单数据的方法
    async loadOrders() {
      try {
        const response = await this.$http.get('/api.php/v1.order/lists')
        if (response.data && response.data.code === 0) {
          const orderData = response.data.data.data
          // 转换订单数据格式
          this.orders = orderData.map(order => this.transformOrderData(order))
        } else {
          console.error('获取订单列表失败:', response.data?.msg || '未知错误')
          this.orders = []
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.orders = []
      }
    },

    // 转换订单数据格式
    transformOrderData(order) {
      // 根据status字段判断订单状态
      let status, statusText
      if (order.status === 0) {
        status = 'unregistered'
        statusText = '未报名'
      } else if (order.status === 1) {
        status = 'pending'
        statusText = '待缴费'
      } else if (order.status === 2) {
        status = 'paid'
        statusText = '已缴费'
      } else if (order.status === 3) {
        status = 'learning'
        statusText = '学习中'
      } else if (order.status === 4) {
        status = 'completed'
        statusText = '已完成'
      } else {
        status = 'unknown'
        statusText = '未知状态'
      }

      return {
        id: order.id,
        cid: order.cid,
        orderNumber: order.orderNum || `ORDER${order.id}`,
        courseName: this.getCourseNameByCid(order.cid),
        price: order.amount ? order.amount / 100 : 0, // amount是分，转换为元
        status: status,
        statusText: statusText,
        createTime: this.formatTime(order.createTime)
      }
    },

    // 根据cid获取课程名称
    getCourseNameByCid(cid) {
      const courseNames = {
        1: '初级咨询师',
        2: '中级咨询师', 
        3: '高级咨询师',
        4: '督导师'
      }
      return courseNames[cid] || '未知课程'
    },

    // 格式化时间
    formatTime(timestamp) {
      if (typeof timestamp === 'string') return timestamp
      
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    // 处理发票类型变化
    handleInvoiceTypeChange(value) {
      if (value === '个人发票') {
        // 选择个人发票时，清空税号
        this.signupForm.taxNumber = ''
        // 移除税号的必填验证
        this.$nextTick(() => {
          if (this.$refs.signupFormRef) {
            this.$refs.signupFormRef.clearValidate('taxNumber')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.notice-root {
  height: 100vh;
  background: #f5f6fa;
  overflow: hidden;
}
.sidebar {
  background: #2a91ff;
  color: #fff;
  height: 100%;
  padding-top: 20px;
  margin-top: 10px;
  border-radius: 8px;
}
.sidebar-header {
  text-align: center;
  margin-bottom: 30px;
}
.sidebar .avatar {
  width: 60px;
  border-radius: 50%;
  margin-bottom: 10px;
  border: none;
}
.username {
  font-size: 18px;
  font-weight: bold;
}
.main-content {
  padding: 30px;
  background: #f5f6fa;
  height: 100%;
  overflow-y: auto;
}
.notice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.notice-header h1 {
  color: #2c3e50;
  font-size: 2em;
  margin: 0;
}
.learning-btn {
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 6px;
}
.notice-list {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.notice-card {
  width: 360px;
  border-radius: 12px;
  overflow: hidden;
}
.notice-title {
  font-size: 1.2em;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 8px;
}
.notice-date {
  font-size: 0.9em;
  color: #7f8c8d;
  margin-bottom: 8px;
}
.notice-description {
  color: #34495e;
  line-height: 1.6;
}

.sidebar >>> .el-menu-item,
.sidebar >>> .el-submenu__title {
  font-size: 16px !important;
  color: #fff !important;
  padding: 0 20px !important;
  height: 50px !important;
  line-height: 50px !important;
}

/* 菜单图标样式 */
.menu-icon {
  color: #fff !important;
  font-size: 18px !important;
  margin-right: 12px !important;
  width: 20px !important;
  text-align: center !important;
}

.submenu-icon {
  color: #fff !important;
  font-size: 16px !important;
  margin-right: 10px !important;
  width: 18px !important;
  text-align: center !important;
}

/* 子菜单项样式 */
.sidebar >>> .el-submenu .el-menu-item {
  font-size: 15px !important;
  padding-left: 45px !important;
  height: 45px !important;
  line-height: 45px !important;
}

/* 菜单项悬停效果 */
.sidebar >>> .el-menu-item:hover,
.sidebar >>> .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* 激活状态样式 */
.sidebar >>> .el-menu-item.is-active {
  background-color: #2a91ff !important;
  position: relative;
}

.sidebar >>> .el-menu-item.is-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #fff;
}
.video-list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 32px;
}
.video-card {
  width: 280px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  cursor: pointer;
}

.video-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}

.video-thumb {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}

.video-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 12px 16px 8px 16px;
  line-height: 1.4;
}

.video-intro {
  font-size: 13px;
  color: #999;
  margin: 0 16px 16px 16px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.loading-state {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.loading-state i {
  font-size: 48px;
  color: #2a91ff;
  margin-bottom: 20px;
  display: block;
}

.loading-state p {
  font-size: 16px;
  margin: 0;
  color: #999;
}
.test-list {
  margin-top: 32px;
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.test-list h3 {
  margin-bottom: 16px;
}
.article-page {
  background: #fff;
  border-radius: 8px;
  padding: 32px 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  max-width: 900px;
  margin: 0 auto;
}
.article-title {
  font-size: 2em;
  font-weight: bold;
  margin-bottom: 12px;
}
.article-date {
  color: #888;
  font-size: 14px;
  margin-bottom: 24px;
}
.article-content {
  font-size: 1.15em;
  color: #333;
  line-height: 2;
}

/* 个人中心样式 */
.personal-center {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
}

.page-header {
  margin-bottom: 25px;
  background: linear-gradient(135deg, #2a91ff 0%, #667eea 100%);
  border-radius: 16px;
  padding: 25px;
  color: white;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  flex: 1;
}

.avatar-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-avatar {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: white;
  backdrop-filter: blur(10px);
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 2em;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: white;
}

.user-title {
  font-size: 1.1em;
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
}

.header-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.stats-cards {
  display: flex;
  gap: 20px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  min-width: 120px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-number {
  font-size: 2.2em;
  font-weight: bold;
  color: white;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9em;
  color: rgba(255, 255, 255, 0.8);
}

.page-subtitle {
  font-size: 1.1em;
  color: #666;
}

.order-section {
  background: white;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  height: calc(100% - 120px);
  overflow-y: auto;
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.section-title i {
  font-size: 24px;
  color: #2a91ff;
}

.section-title h2 {
  font-size: 1.6em;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.order-tabs {
  border-bottom: 1px solid #e9ecef;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.order-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.order-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2a91ff, #667eea);
}

.order-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(42, 145, 255, 0.15);
  border-color: #2a91ff;
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f5f5f5;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.order-number {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.order-number i {
  color: #2a91ff;
  font-size: 16px;
}

.order-date {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #666;
  font-size: 14px;
}

.order-date i {
  color: #999;
  font-size: 14px;
}

.order-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.course-info {
  display: flex;
  align-items: flex-start;
  flex: 1;
  gap: 20px;
}

.course-image-wrapper {
  position: relative;
  flex-shrink: 0;
}

.course-image {
  width: 120px;
  height: 80px;
  object-fit: cover;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.course-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(42, 145, 255, 0.8);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.course-overlay i {
  font-size: 24px;
  color: white;
}

.course-image-wrapper:hover .course-overlay {
  opacity: 1;
}

.course-image-wrapper:hover .course-image {
  transform: scale(1.05);
}

.course-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.course-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.3;
}

.course-meta {
  display: flex;
  gap: 24px;
  margin-top: 8px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
}

.meta-item i {
  color: #2a91ff;
  font-size: 14px;
}

.progress-section {
  margin-top: 12px;
}

.progress-text {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.order-price {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  min-width: 120px;
}

.price-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.price {
  font-size: 28px;
  font-weight: bold;
  color: #2a91ff;
  line-height: 1;
}

.order-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #f5f5f5;
  margin-top: 16px;
}

.action-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  padding: 10px 20px;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.primary-btn {
  background: linear-gradient(135deg, #2a91ff, #667eea);
}

.success-btn {
  background: linear-gradient(135deg, #52c41a, #73d13d);
}

.warning-btn {
  background: linear-gradient(135deg, #faad14, #ffc53d);
}

.info-btn {
  background: #f5f5f5;
  color: #666;
}

.info-btn:hover {
  background: #e6f7ff;
  color: #2a91ff;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #999;
  background: #fafafa;
  border-radius: 12px;
  margin: 20px 0;
}

.empty-state i {
  font-size: 80px;
  color: #d9d9d9;
  margin-bottom: 24px;
  display: block;
}

.empty-state p {
  font-size: 18px;
  margin: 0;
  color: #666;
}
/* 报名弹窗标题和按钮居中 */
.signup-dialog-center-title >>> .el-dialog__header {
  text-align: center;
  padding-bottom: 0;
}
.signup-dialog-center-title >>> .el-dialog__title {
  display: inline-block;
  font-weight: bold;
  font-size: 1.6em;
  letter-spacing: 2px;
  color: #2a91ff;
}
.signup-dialog-center-title >>> .dialog-footer {
  text-align: center;
  margin-top: 18px;
}
/* 美化弹窗整体 */
.signup-dialog-center-title >>> .el-dialog {
  border-radius: 18px;
  box-shadow: 0 8px 40px rgba(42,145,255,0.18), 0 1.5px 8px rgba(0,0,0,0.08);
}
/* 表单项间距 */
.signup-dialog-center-title >>> .el-form-item {
  margin-bottom: 26px !important;
}
/* 输入框美化 */
.signup-dialog-center-title >>> .el-input__inner,
.signup-dialog-center-title >>> textarea.el-input__inner {
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(42,145,255,0.06);
  transition: border-color 0.2s, box-shadow 0.2s;
}
.signup-dialog-center-title >>> .el-input__inner:focus,
.signup-dialog-center-title >>> textarea.el-input__inner:focus {
  border-color: #2a91ff;
  box-shadow: 0 0 0 2px rgba(42,145,255,0.15);
}
/* 按钮美化 */
.signup-dialog-center-title >>> .el-button {
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 32px;
  transition: transform 0.15s, box-shadow 0.15s;
}
.signup-dialog-center-title >>> .el-button--primary {
  background: linear-gradient(90deg, #2a91ff 0%, #667eea 100%);
  border: none;
  color: #fff;
  box-shadow: 0 2px 8px rgba(42,145,255,0.10);
}
.signup-dialog-center-title >>> .el-button--primary:hover {
  transform: scale(1.06);
  box-shadow: 0 4px 16px rgba(42,145,255,0.18);
}
.signup-dialog-center-title >>> .el-button:not(.el-button--primary):hover {
  transform: scale(1.04);
}
/* 表单分组标题样式 */
.form-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2a91ff;
  margin: 20px 0 15px 0;
  padding: 8px 0;
  border-bottom: 2px solid #e6f7ff;
  position: relative;
}

.form-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 30px;
  height: 2px;
  background: #2a91ff;
}

/* 收件信息提示左对齐 */
.signup-tip-left {
  color: #888;
  font-size: 13px;
  margin-top: 4px;
  text-align: left;
}

/* 支付弹窗样式 */
.payment-dialog >>> .el-message-box {
  width: 90vw !important;
  max-width: 900px !important;
  height: 90vh !important;
  max-height: 900px !important;
}

.payment-dialog >>> .el-message-box__content {
  height: calc(100% - 120px);
  overflow-y: auto;
  padding: 0;
}

.payment-dialog >>> .el-message-box__message {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.payment-dialog >>> .el-message-box__message > div {
  height: 100%;
  overflow: hidden;
}

/* 支付弹窗内容样式 */
.payment-dialog >>> .el-message-box__message .wrap {
  min-height: auto !important;
  padding: 20px;
}

.payment-dialog >>> .el-message-box__message .card {
  max-width: none !important;
  width: 100% !important;
  margin: 0 auto;
}

.payment-dialog >>> .el-message-box__message .qrcode-box img {
  max-width: 100% !important;
  height: auto !important;
}

/* 确保支付页面样式正确显示 */
.payment-dialog >>> .el-message-box__message body {
  margin: 0 !important;
  padding: 0 !important;
}

.payment-dialog >>> .el-message-box__message .wrap {
  min-height: auto !important;
}

.payment-dialog >>> .el-message-box__message .card {
  box-shadow: none !important;
  border: none !important;
}

/* 缴费页面样式 */
.payment-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.payment-header {
  text-align: center;
  margin-bottom: 40px;
}

.payment-header h2 {
  font-size: 2.5em;
  color: #333;
  margin-bottom: 16px;
}

.payment-header p {
  font-size: 1.2em;
  color: #666;
  margin: 0;
}

.payment-content {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.payment-info {
  margin-bottom: 40px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item .label {
  font-size: 1.1em;
  color: #666;
  font-weight: 500;
}

.info-item .value {
  font-size: 1.1em;
  color: #333;
  font-weight: 600;
}

.info-item .status-pending {
  color: #faad14;
  background: #fff7e6;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.9em;
}

.info-item .price {
  color: #f5222d;
  font-size: 1.3em;
  font-weight: bold;
}

.payment-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.payment-actions .el-button {
  min-width: 120px;
  height: 48px;
  font-size: 1.1em;
}

@media (max-width: 768px) {
  .payment-page {
    padding: 20px 15px;
  }
  
  .payment-content {
    padding: 30px 20px;
  }
  
  .payment-actions {
    flex-direction: column;
    gap: 15px;
  }
  
  .payment-actions .el-button {
    width: 100%;
  }
}
/* 新增：支付二维码弹窗样式（基于用户提供样式精简适配） */
/* 确保作用到真正的对话框元素（custom-class 直接加在 .el-dialog 上） */
::v-deep .payment-dialog {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
::v-deep .payment-dialog .el-dialog__header {
  display: none !important;
}
::v-deep .payment-dialog .el-dialog__body {
  padding: 0 !important;
  background: transparent !important;
}
.payment-dialog .wrap {
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.payment-dialog .card {
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 25px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}
.payment-dialog .brand {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.payment-dialog .brand .title {
  font-size: 20px;
  color: #333;
  margin-bottom: 0;
}
.payment-dialog .subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}
.payment-dialog .status {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.payment-dialog .status .dot {
  width: 8px;
  height: 8px;
  background-color: #4CAF50;
  border-radius: 50%;
  margin-right: 8px;
}
.payment-dialog .status span {
  font-size: 16px;
  color: #333;
}
.payment-dialog .qrcode-box {
  margin-bottom: 20px;
}
.payment-dialog .meta {
  margin-bottom: 20px;
}
.payment-dialog .meta .row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.payment-dialog .meta .key {
  margin-right: 10px;
}
.payment-dialog .actions {
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
}
.payment-dialog .actions .btn {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.3s ease;
}
.payment-dialog .actions .btn:hover {
  opacity: 0.9;
}
.payment-dialog .actions .btn.primary {
  background-color: #4CAF50;
  color: white;
}
.payment-dialog .actions .btn.primary:hover {
  background-color: #45a049;
}
.payment-dialog .actions .btn:last-child {
  background-color: #f44336;
  color: white;
}
.payment-dialog .actions .btn:last-child:hover {
  background-color: #d32f2f;
}
.payment-dialog .tips {
  font-size: 12px;
  color: #666;
  margin-bottom: 15px;
}
.payment-dialog .brand .logo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}
/* 锁定课程样式 */
.locked-course {
  opacity: 0.6;
  cursor: not-allowed;
}

.locked-course:hover {
  background-color: transparent !important;
}

.lock-icon {
  margin-left: auto;
  color: #fff;
  font-size: 14px;
}

/* 禁用状态的菜单项样式 */
.el-menu-item.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.el-menu-item.is-disabled:hover {
  background-color: transparent !important;
}

/* 课程标题和按钮的容器 */
.course-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

/* 报名按钮容器样式 */
.signup-button-container {
  display: inline-block;
  margin: 0;
  padding: 0;
}

/* 报名按钮样式 */
.signup-button {
  padding: 8px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 6px;
  margin: 0;
}

/* 视频列表后的报名按钮容器样式 */
.video-list + .signup-button-container {
  text-align: center;
  margin: 30px 0;
  display: block;
}

/* 视频列表后的报名按钮样式 */
.video-list + .signup-button-container .signup-button {
  padding: 15px 40px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
  min-width: 200px;
}

.locked-video {
  opacity: 0.7;
  cursor: pointer;
  position: relative;
}

.locked-video:hover {
  opacity: 0.8;
}

/* 视频缩略图容器 */
.video-thumb-container {
  position: relative;
  display: inline-block;
}

/* 锁覆盖层 */
.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

/* 大锁图标 */
.lock-icon-large {
  font-size: 32px;
  color: #fff;
}
</style> 